module.exports = __webpack_public_path__ + "img/banner_generic_left.803476b6.jpg";